<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Отправка оповещений</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-tabs expanded type="is-toggle">
          <b-tab-item expanded label="SMS" icon="message">
            <div class="columns">
              <div class="column">
                <b-field label="Ссылка">
                  <b-input v-model="settings.sms.url"></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Время отправки">
                  <b-datetimepicker
                    v-model="settings.sms.planned_at"
                    placeholder="Выбрать время"
                  >
                    <template slot="left">
                      <button
                        class="button is-primary"
                        @click="settings.sms.planned_at = new Date()"
                      >
                        <b-icon icon="clock"></b-icon>
                        <span>Now</span>
                      </button>
                    </template>
                    <template slot="right">
                      <button
                        class="button is-danger"
                        @click="settings.sms.planned_at = null"
                      >
                        <b-icon icon="close"></b-icon>
                        <span>Clear</span>
                      </button>
                    </template>
                  </b-datetimepicker>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Метка рассылки">
                  <b-input v-model="settings.sms.source"></b-input>
                </b-field>
              </div>
            </div>
            <b-field expanded label="Шаблон СМС">
              <b-input
                expanded
                maxlength="200"
                type="textarea"
                v-model="settings.sms.text_template_a"
              ></b-input>
            </b-field>

            <b-field
              v-if="!!settings.sms.text_template_a"
              expanded
              label="Максимальная длина СМС"
            >
              <b>{{ max_sms.length }}</b
              >: {{ max_sms }}
            </b-field>

            <div class="columns">
              <div class="column">
                <p><b>Доступные переменные:</b></p>
                <p><b>{short_link}</b> - Короткая ссылка</p>
                <p><b>{name}</b> - Имя клиента</p>
                <p><b>[item1|item2|...]</b> - Случайный выбор из вариантов</p>
              </div>
              <div class="column">
                <p><b>Пример:</b></p>
                <p>
                  [Займ|Заем|Заём] без процентов от [банк|банка] инфо
                  {short_link}
                </p>
                <p>З=аём без процентов от бан;ка инфо {short_link}</p>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <b-button
                  type="is-primary"
                  class="is-pulled-right"
                  icon-left="plus"
                  @click="createModal('sms')"
                  >Cоздать уведомление</b-button
                >
              </div>
            </div>
          </b-tab-item>
          <b-tab-item expanded label="Call" icon="phone">
            <div class="columns">
              <div class="column">
                <b-field label="Шаблон рассылки">
                  <b-select
                    placeholder=""
                    icon="duck"
                    v-model="settings.call.call_template_a"
                  >
                    <option
                      v-for="template in templates"
                      :value="template.id"
                      :key="template.id"
                    >
                      {{ template.name }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Время отправки">
                  <b-datetimepicker
                    v-model="settings.call.planned_at"
                    placeholder="Выбрать время"
                  >
                    <template slot="left">
                      <button
                        class="button is-primary"
                        @click="settings.call.planned_at = new Date()"
                      >
                        <b-icon icon="clock"></b-icon>
                        <span>Now</span>
                      </button>
                    </template>
                    <template slot="right">
                      <button
                        class="button is-danger"
                        @click="settings.call.planned_at = null"
                      >
                        <b-icon icon="close"></b-icon>
                        <span>Clear</span>
                      </button>
                    </template>
                  </b-datetimepicker>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Метка рассылки">
                  <b-input v-model="settings.call.source"></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Использовать дежурный номер?">
                  <b-switch v-model="settings.call.from_duty_phone"></b-switch>
                </b-field>
              </div>
              <div class="column" v-if="!settings.call.from_duty_phone">
                <b-field label="Список номеров:">
                  <b-select
                    placeholder="Номер телефона"
                    icon="duck"
                    v-model="settings.call.outgoing_phone"
                    :loading="isPhonesLoading"
                  >
                    <option
                      v-for="phone in phones"
                      :value="phone.phone"
                      :key="phone.id"
                    >
                      {{ phone.phone }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-button
                  type="is-primary"
                  class="is-pulled-right"
                  icon-left="plus"
                  @click="createModal('call')"
                  >Cоздать уведомление</b-button
                >
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import CreateNotifications from "../shared/modals/createNotifications";

import MultiplySelect from "@/app/shared/components/form-inputs/MultiplySelect";

export default {
  name: "InstantNotifications",
  components: {
    CreateNotifications,
    MultiplySelect,
  },
  created() {
    this.$store.dispatch("GET_PHONES");
    this.$store.dispatch("GET_TEMPLATES");
    this.$store.dispatch("GET_NOTIFICATION_SETTINGS");
  },
  data() {
    return {
      settings: {
        sms: {
          url: null,
          planned_at: new Date(),
          source: null,
          text_template_a: null,
          text_template_b: null,
          is_ab_type: false,
        },
        call: {
          template_id: null,
          planned_at: new Date(),
          source: null,
          from_duty_phone: false,
          outgoing_phone: null,
          call_template_a: null,
          call_template_b: null,
          is_ab_type: false,
        },
      },
    };
  },
  computed: {
    templates() {
      return this.$store.getters.TEMPLATES;
    },
    phones() {
      return this.$store.getters.PHONES;
    },
    isPhonesLoading() {
      return this.$store.getters.PHONES_IS_LOADING;
    },
    templateNameList() {
      return Object.keys(this.$store.getters.NOTIFICATION_EMAIL_TEMPLATES);
    },
    max_sms() {
      if (!!this.settings.sms.text_template_a) {
        // prettier-ignore
        var re = /\[([0-9А-Яа-яё\.\,\s\|]*)\]/gm;
        var tmp = this.settings.sms.text_template_a;
        // [Займ|Заем|Заём] без процентов от [банк|банка] инфо {short_link}
        var replacements = this.settings.sms.text_template_a.match(re);
        var repl_dict = {};
        if (replacements) {
          for (let index = 0; index < replacements.length; index++) {
            const element = replacements[index];
            repl_dict["f" + index] = element.replace(/\[|\]/gm, "").split("|");
            tmp = tmp.replace(element, "f" + index);
          }
          for (const key of Object.keys(repl_dict)) {
            tmp = tmp.replace(
              key,
              this.rand_replace(
                repl_dict[key].reduce(
                  (r, s) => (r.length > s.length ? r : s),
                  0
                )
              )
            );
          }
          console.log(repl_dict);
        }

        return tmp;
      }
    },
  },
  methods: {
    rand_replace(str) {
      var r = ")(&%$!-=+/>”;#^~";
      var position = Math.floor(Math.random() * Math.floor(str.length));
      return (
        str.substring(0, position) +
        r[Math.floor(Math.random() * Math.floor(r.length))] +
        str.substring(position)
      );
    },
    createModal(channel) {
      if (
        this.settings[channel].url ||
        this.settings["call"].call_template_a
      ) {
        const props = {
          channel,
          settings: this.settings[channel],
          user: this.authUser,
        };
        this.$buefy.modal.open({
          parent: this,
          props,
          component: CreateNotifications,
          hasModalCard: true,
          width: 2000,
        });
      }
    },
  },
};
</script>

<style>
.tabs.is-toggle li.is-active a {
  background-color: #1d8f68;
}
.element-bg-cyan.is-primary {
  background-color: #1d8f68;
}
</style>
